import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';

const SelfExclusionLoadable = Loadable({ loader: imports.selfExclusion, exp: Exp => Exp.SelfExclusion });
export default SelfExclusionLoadable;
